var _rect, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircularBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.329102,
    y: 0.945312,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3291,
    cy: 18.9453,
    r: 12,
    fill: "white",
    stroke: "#244F7C",
    strokeDasharray: "2 2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBorder);
export default __webpack_public_path__ + "static/media/circular-border.19800df1f3711e426c694a8e5a210ba1.svg";
export { ForwardRef as ReactComponent };